import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsDepartmentsListRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('department');
  }
}

export default instrumentRoutePerformance(SettingsDepartmentsListRoute);
